import { faBars, faFutbol } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import FlexSpacer from "../../shared/FlexSpacer";
import fontAwesomeToImg from "../../shared/utils/fontAwesomeToImg";
import VerticalDivider from "../../shared/VerticalDivider";
import HeaderLogo from "./header/HeaderLogo";
import HeaderNavBar from "./header/HeaderNavBar";
import NotificationBadge from "./header/NotificationBadge";

const Header = () => {
  // const appLogo =
  //   "https://via.placeholder.com/64/40fb0f/ffffff?Text=FPL";

  const appLogo = fontAwesomeToImg({path: faFutbol.icon[4], color: '#40fb0f'});

  const [isOpenMenu, setIsOpenMenu] = useState(false);

  const toggleMenu = () => setIsOpenMenu(!isOpenMenu);

  const hideMenu = () => setIsOpenMenu(false);



  return (
    <header className="fixed bg-white h-16 w-full lg:flex lg:flex-row z-40">
      <HeaderLogo className="hidden lg:contents" imgSrc={appLogo} />
      <div className="flex lg:hidden w-full">
        <HeaderLogo imgSrc={appLogo} />
        <FlexSpacer />
        <NotificationBadge  />
        <button className="mx-3 px-4 text-gray-400 hover:text-gray-500" onClick={toggleMenu}>
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div>
      <HeaderNavBar isOpen={isOpenMenu} appLogo={appLogo} onOverlayClick={hideMenu} />
      <div className="flex">
        <VerticalDivider
          className="invisible lg:visible"
          colorClass="bg-gray-200"
        />
        <div className="invisible lg:visible flex flex-grow items-center justify-center">
          <button className="bg-cyan-300 hover:bg-cyan-400 py-2 px-4 mr-4 ml-3 w-36 font-bold text-black text-xs uppercase">
            GameWeek is Live
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
